import { getMykissEnv } from './getMykissEnv';

export function isTesting(): boolean {
  return getMykissEnv() === 'testing';
}
